import React from "react";
import { Link } from "@/components/common/Link";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import {
  ShopBreadcrumbsProvider,
  useShopBreadcrumbs,
} from "@/integrations/wordpress/WordPressEcommerceShopBreadcrumbs";

function PageHeaderConsumer() {
  const { links, loading, error } = useShopBreadcrumbs();

  if (loading) {
    return (
      <div className="w-full space-y-4">
        <div className="h-4 w-32 animate-pulse rounded bg-muted" />
        <div className="h-10 w-64 animate-pulse rounded bg-muted" />
      </div>
    );
  }

  if (error) {
    return null;
  }

  if (!links || links.length === 0) {
    return null;
  }

  const lastIndex = links.length - 1;
  const currentTitle = links[lastIndex]?.title;

  return (
    <div className="flex flex-col items-start gap-4">
      <Breadcrumb>
        <BreadcrumbList>
          {links.map((link, index) => {
            const isLast = index === lastIndex;
            return (
              <React.Fragment key={link.href + index}>
                <BreadcrumbItem>
                  {isLast ? (
                    <BreadcrumbPage className="font-medium text-foreground">
                      {link.title}
                    </BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link to={link.href} className="transition-colors hover:text-primary">
                        {link.title}
                      </Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
                {!isLast && <BreadcrumbSeparator />}
              </React.Fragment>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>

      <h1 className="font-serif text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
        {currentTitle}
      </h1>
    </div>
  );
}

export default function PageTitleAndNavigation() {
  return (
    <section
      id="page-title-and-navigation"
      className="bg-background border-b border-border py-12 md:py-16"
    >
      <div className="container mx-auto px-4">
        <ShopBreadcrumbsProvider>
          <PageHeaderConsumer />
        </ShopBreadcrumbsProvider>
      </div>
    </section>
  );
}